import React, { useEffect, useRef } from 'react'
import HeaderComponent from '../components/HeaderComponent'

export const CustodianViewerPage = ({ instanceData }) => {

  const title = instanceData?.title || 'Purview Image'
  useEffect(() => {
    document.title = title
  }, [title])
  
  const iframeSrcRef = useRef(null)
  if (!iframeSrcRef.current) {
    iframeSrcRef.current = `/wl/worklist/viewer-loading${window.location.search || ''}`
  }

  return <div style={{height: '100%', minHeight: '100%', display: 'flex', flexDirection: 'column'}}>
    <HeaderComponent withLoading />
    <iframe 
      src={iframeSrcRef.current} 
      width={'100%'} 
      title={title} 
      style={{border: '0px', margin: '0px', padding: '0px', height: '100%'}}>
    </iframe>
  </div>
}